export const objectHasValues = <Data>(
  values: Partial<Data> | undefined
): values is Data =>
  Object.values(values || {}).some((value) => value !== undefined);
